<div *ngIf="isOpen" class="dcc-modal" role="dialog" aria-modal="true">
  <header class="dcc-modal__header">
    <div>
      <h2>{{ title }}</h2>
      <p *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button
      type="button"
      class="dcc-modal__close"
      (click)="close()"
      aria-label="Cerrar"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="dcc-modal__body">
    <!-- Loader mientras se inicializa la cámara -->
    <div *ngIf="loading && !currentImage" class="dcc-loading">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Preparando cámara...</span>
    </div>

    <!-- Vista de captura (cámara en vivo) -->
    <div
      *ngIf="!currentImage"
      class="dcc-camera-container"
      [class.dcc-camera-container--hidden]="loading"
    >
      <video #video autoplay playsinline></video>

      <!-- Frame overlay. Para documentos: 4 esquinas rectangulares
           (mismo look que el onboarding). Para selfies: óvalo tipo
           retrato — el rectángulo con esquinas hacía creer al cliente
           que había que fotografiar sólo el documento. -->
      <div
        *ngIf="frameShape === 'document'"
        class="dcc-frame"
        [style.aspect-ratio]="frameAspectRatio.toString()"
      >
        <div class="dcc-frame__corner dcc-frame__corner--tl"></div>
        <div class="dcc-frame__corner dcc-frame__corner--tr"></div>
        <div class="dcc-frame__corner dcc-frame__corner--bl"></div>
        <div class="dcc-frame__corner dcc-frame__corner--br"></div>
      </div>

      <div
        *ngIf="frameShape === 'face'"
        class="dcc-face-frame"
        [style.aspect-ratio]="frameAspectRatio.toString()"
      >
        <div class="dcc-face-frame__oval"></div>
      </div>

      <!-- Botón "Cambiar cámara" — solo si el dispositivo tiene más de
           una cámara. Sirve para alternar frontal ↔ trasera cuando el
           preferredFacing no es el adecuado (ej. selfie con cámara
           trasera, o documentos con cámara frontal si la trasera
           falla). -->
      <button
        *ngIf="hasMultipleCameras"
        type="button"
        class="dcc-flip-btn"
        (click)="toggleCamera()"
        [disabled]="loading || !isReadyToCapture"
        [attr.aria-label]="currentFacing === 'environment' ? 'Cambiar a cámara frontal' : 'Cambiar a cámara trasera'"
        title="Cambiar cámara"
      >
        <mat-icon>flip_camera_ios</mat-icon>
      </button>

      <p class="dcc-hint">
        {{ frameShape === 'face' ? 'Ubicá tu rostro dentro del óvalo' : 'Alineá el documento dentro del marco' }}
      </p>
    </div>

    <!-- Preview después de capturar -->
    <div *ngIf="currentImage" class="dcc-preview">
      <div class="dcc-preview__wrapper">
        <img
          [src]="currentImage"
          [style.transform]="'rotate(' + rotationAngle + 'deg)'"
          alt="Documento capturado"
        />
      </div>
      <div class="dcc-preview__hint">
        Para uso exclusivo de verificación de identidad
      </div>
    </div>
  </div>

  <!-- Barra de acciones -->
  <footer class="dcc-modal__actions">
    <ng-container *ngIf="!currentImage">
      <button
        type="button"
        class="dcc-btn dcc-btn--ghost"
        (click)="close()"
        [disabled]="loading"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="dcc-btn dcc-btn--capture"
        (click)="capture()"
        [disabled]="!isReadyToCapture || loading"
      >
        <mat-icon>photo_camera</mat-icon>
        Tomar foto
      </button>
    </ng-container>

    <ng-container *ngIf="currentImage">
      <button
        type="button"
        class="dcc-btn dcc-btn--ghost"
        (click)="retake()"
        [disabled]="loading"
      >
        <mat-icon>refresh</mat-icon>
        Repetir
      </button>
      <button
        type="button"
        class="dcc-btn dcc-btn--icon"
        (click)="rotateLeft()"
        [disabled]="loading"
        title="Rotar a la izquierda"
      >
        <mat-icon>rotate_left</mat-icon>
      </button>
      <button
        type="button"
        class="dcc-btn dcc-btn--icon"
        (click)="rotateRight()"
        [disabled]="loading"
        title="Rotar a la derecha"
      >
        <mat-icon>rotate_right</mat-icon>
      </button>
      <button
        type="button"
        class="dcc-btn dcc-btn--primary"
        (click)="confirm()"
        [disabled]="loading"
      >
        <mat-spinner *ngIf="loading" diameter="16"></mat-spinner>
        <mat-icon *ngIf="!loading">check</mat-icon>
        Usar esta foto
      </button>
    </ng-container>
  </footer>
</div>
